import React from "react";
import Media from "@qlik/qlik/src/components/Media";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import RichText from "@qlik/qlik/src/components/RichText";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import Cta from "@qlik/qlik/src/components/Cta";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

const LeftAndRightImageHalf = ({ data }) => {
    const { cardItem, additionalConfiguration, backgroundColor, customId, id } = data || {};
    const { eyebrowText, title, subtitle, description, cta, media, body } = cardItem || {};
    const orderMediaText = String(additionalConfiguration?.contentOrder) === "Media/Text";
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    const sectionPaddingClassName = getSpacingClassName(additionalConfiguration, "lg:py-30");
    return (
        <section
            data-section
            id={customId ?? id}
            className={` ${sectionPaddingClassName} scroll-mt-45 ${sectionColorMapping.bgColor || "bg-stone-light"}`}
        >
            <div className="container">
                <div
                    className={`flex flex-col-reverse items-center lg:flex-row gap-7.5 md:gap-25 ${
                        orderMediaText ? "lg:flex-row-reverse" : ""
                    }`}
                >
                    <div className={`${styles.left} `}>
                        {eyebrowText && <p className="text-ocean leading-none tracking-wide5 tag-1">{eyebrowText}</p>}
                        {title && (
                            <h2
                                className={`${styles.cardTitles} md:title-3 text-xl my-3.75`}
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                            />
                        )}
                        {subtitle && (
                            <h4
                                className={`${styles.cardTitles} text-xl mt-1.5 tracking-normal`}
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(subtitle) }}
                            />
                        )}
                        {description?.description && <p>{description.description}</p>}
                        {body && <RichText data={cardItem} className={styles.bodyContent} />}
                        {cta && (
                            <div className="flex mt-6 gap-0 flex-col">
                                {cta.map((link) => (
                                    <div key={link.id} className="mt-1">
                                        <Cta data={link} />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="w-full basis-2/4">
                        {media?.[0] && (
                            <Media media={media[0]} className="w-full rounded-xs md:rounded" videoClassName="rounded" />
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LeftAndRightImageHalf;
